import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToolsService } from 'src/app/services/tools.service';
export class AutomaticPointsSettingsPage {
    constructor(modalController, authService, analyticsService, toolsService) {
        this.modalController = modalController;
        this.authService = authService;
        this.analyticsService = analyticsService;
        this.toolsService = toolsService;
        this.analyticsService.AnalyticsServiceModalView('automatic-points-settings');
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.playerData = yield this.authService.getPlayerFullData(false);
        });
    }
    automaticRedemptionUpdate(newState) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            ///Function to activate automatic redemption
            yield this.toolsService.showLoader();
            try {
                yield this.authService.updateAutoRedemptionWalletData(newState);
            }
            catch (error) {
                console.error('[automatic-points-settings.page] automaticRedemptionUpdate()', error);
            }
            finally {
                this.toolsService.showSuccessToast(newState ? 'Redención automática activada' : 'Redención automática desactivada');
            }
            yield this.toolsService.dismissLoader();
            this.closeModal();
        });
    }
    //Function to close modal
    closeModal() {
        this.modalController.dismiss();
    }
    get showDeactivateButton() {
        if (this.playerData && this.playerData.automatic_redemption_wallet == false)
            return false;
        return true;
    }
    get showActivateButton() {
        if (this.playerData && this.playerData.automatic_redemption_wallet == true)
            return false;
        return true;
    }
    get deactivateText() {
        if (this.playerData && this.playerData.automatic_redemption_wallet == true)
            return 'Desactivar';
        return 'No activar';
    }
}
